import React, { useEffect, useState } from 'react';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import WPAPI from 'wpapi';
import Parser from 'html-react-parser';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundColor: '#F2FAFE',
    paddingTop: 81,
    paddingBottom: 81,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 80,
      paddingBottom: 80,
    },
  },
  container: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    fontFamily: 'PoppinsSemiBold',
    fontWeight: '600',
    fontSize: 35,
    lineHeight: '1.1em',
    textAlign: 'center',
    color: '#333333',
    marginBottom: '2.75%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 40,
    },
  },
  solutionsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  solution: {
    width: '29.667%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '11.5%',
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  solutionItem: {
    backgroundColor: '#FFFFFF',
    border: '1px solid rgba(0,0,0,0.08)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  solutionImage: {
    width: '100%',
    height: 200,
    objectFit: 'cover',
  },
  solutionData: {
    width: '100%',
    padding: '30px 19px 19px 19px',
  },
  solutionTitle: {
    fontFamily: 'OpenSansRegular',
    fontSize: 18,
    color: '#333333',
    lineHeight: '1em',
    paddingBottom: 10,
  },
  solutionBody: {
    fontFamily: 'OpenSansRegular',
    fontSize: 14,
    color: '#666666',
    lineHeight: '1.7em',
  },
}));

function SolutionsSection() {
  const classes = useStyles();

  const [items, setItems] = useState([]);
  const [solutionsSiteCopy] = useSiteCopySelector(['solutions-homepage']);
  const config = _get(solutionsSiteCopy, 'pageCopy.solutions-section', {});

  useEffect(() => {
    const client = new WPAPI({
      endpoint: 'https://solutions.crediblemind.com/wp-json',
    });
    client
      .posts()
      .categories(27)
      .get((err, data) => {
        if (data) setItems(data.slice(0, 3));
      });
  }, []);

  if (_isEmpty(items)) return null;

  return (
    <section id="solutions-section">
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <Typography className={classes.header}>{config.title}</Typography>
          <div className={classes.solutionsWrapper}>
            {items.map(item => (
              <div className={classes.solution}>
                <a href={_get(item, 'link')} target="_blank">
                  <div className={classes.solutionItem}>
                    <img
                      src={
                        _has(item, 'yoast_head_json.og_image.0.url') &&
                        `https://i0.wp.com/${_get(
                          item,
                          'yoast_head_json.og_image.0.url',
                          '',
                        ).replace('https://', '')}?resize=400,250`
                      }
                      className={classes.solutionImage}
                      alt=""
                    />
                    <div className={classes.solutionData}>
                      <Typography className={classes.solutionTitle}>
                        {Parser(_get(item, 'title.rendered'))}
                      </Typography>
                      <Typography className={classes.solutionBody}>
                        {_get(item, 'yoast_head_json.description')}
                      </Typography>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SolutionsSection;
